import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {createDefaultDialogConfig} from '../common/dialog-utils';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
    selector: 'loading-dialog',
    templateUrl: './loading-dialog.component.html',
    styleUrls: ['./loading-dialog.component.scss'],
    imports: [MatProgressSpinnerModule]
})
export class LoadingDialogComponent implements OnInit {

  message:string;

  constructor(@Inject(MAT_DIALOG_DATA) data) {

    this.message = data.message;

  }

  ngOnInit() {

  }


}


export function showLoadingDialog(dialog: MatDialog, message:string) {

  const dialogConfig = createDefaultDialogConfig();

  dialogConfig.minWidth = '450px';
  dialogConfig.minHeight = '200px';

  dialogConfig.data = {message};

  const waitingDialogRef = dialog.open<LoadingDialogComponent>(LoadingDialogComponent, dialogConfig);

  return waitingDialogRef;
}
